import React, {useCallback, useEffect, useState} from "react";
import {BrowserRouter as Router} from "react-router-dom";
import {Cloudinary} from "@cloudinary/url-gen";
import AppWrapper from "./components/AppWrapper/AppWrapper";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import {preventMediaDownload, applyProtectionStyles} from "./utils/protectMedia";
import {loadDataWithCache} from "./utils";
import './App.scss';

export const ProjectsContext = React.createContext({});
function App() {
    const cld = new Cloudinary({cloud: {cloudName: 'dlkzchunj'} });
    const [laurels, setLaurels] = useState(null);
    const [imagesCache, setImagesCache] = useState({});

    const getLaurels = useCallback(async () => {
        const res = await loadDataWithCache('laurels', imagesCache, setImagesCache);
        setLaurels(res);
    }, [imagesCache, setImagesCache]);

    useEffect(() => {
        getLaurels();
        // Apply media protection on component mount
        preventMediaDownload();
        applyProtectionStyles();
    }, [getLaurels])

    return (
        <ProjectsContext.Provider value={{cld, laurels, imagesCache, setImagesCache}}>
            {<Router>
                <ScrollToTop/>
               <div className="App">
                    <AppWrapper/>
                </div>
            </Router>}
        </ProjectsContext.Provider>
    );
}

export default App;